// frontend/src/pages/admin/AdminDashboard.jsx

import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/axios';

const AdminDashboard = () => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchAssignedLeads = useCallback(async () => {
        try {
            const response = await api.get('/admin/dashboard/my_assigned_leads');
            setLeads(response.data);
        } catch (error) {
            console.error("Failed to fetch assigned leads", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchAssignedLeads();
    }, [fetchAssignedLeads]);

    if (loading) return <p>Loading your dashboard...</p>;

    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold">My Assigned Leads</h1>
                <Link to="/business/new" className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">
                    Add New Lead
                </Link>
            </div>
            
            <div className="bg-white shadow-md rounded-lg overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Lead Name</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Owner</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date Assigned</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {leads.map(lead => (
                            <tr key={lead.id}>
                                <td className="px-6 py-4">{lead.name}</td>
                                <td className="px-6 py-4">{lead.owner_name || 'N/A'}</td>
                                <td className="px-6 py-4">{new Date(lead.created_at).toLocaleDateString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminDashboard;